module.exports = __webpack_public_path__ + "img/parter-work2.6a7e0437.png";